import { useTypedQuery } from "hooks";
import { CommunicationTemplatesQueryKeys } from "modules/CommunicationTemplates/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDefaultTemplatesQuery = () =>
  useTypedQuery({
    queryKey: CommunicationTemplatesQueryKeys.getDefaultTemplates,
    queryFn: async () =>
      (await ApiInstance.get(CommunicationTemplatesQueryKeys.getDefaultTemplates.endpoint, CommunicationTemplatesQueryKeys.getDefaultTemplates.baseUrl)).data
        .communication_mediums
  });
